(function(){
    'use strict';

    angular
    .module('appback')
    .controller('UsuarioController', UsuarioController)
 
    UsuarioController.$inject = ["UsuarioService","GenerallabService","$http","$timeout", "$log", "$document","$sce"];
              
    function UsuarioController(UsuarioService,GenerallabService,$http,$timeout, $log, $document,$sce)
    {                         
        var vm = this;
        vm.generalLab = GenerallabService;
        vm.user = [];
        vm.evaluacion = [];

        vm.saveUser = function(){
            console.log("saveUser",vm.user);
            UsuarioService.saveUser(vm.user, function(response){
            })
        }

        vm.getUserInfo = function(){
            UsuarioService.getUserInfo(function(data){
                console.log("getUserInfo",data);
                vm.user = data.user;
            })
        }

        vm.getEvaluacionUser = function(id){
            console.log("getting evaluacion user", id);
            UsuarioService.getEvaluacion(id,function(data){
                vm.evaluacion = data.evaluacion;
            })
        }
    }
  
})();